import axios from '@/plugins/axios.js';
import wait from '@/plugins/vue-wait.js';

export default {
    /**
     * Set the selected date for appointments
     */
    setSelectedDate({ state, commit, dispatch }, { date, fetch = true }) {
        if (!date || date === 'today') {
            date = moment().format('YYYY-MM-DD');
        }

        if (date === state.selectedDate) {
            return;
        }

        commit('setSelectedDate', date);

        if (fetch) {
            dispatch('fetchAppointments');
        }
    },

    async fetchAppointments({ state, commit, rootState }) {
        wait.start('fetching.appointments');

        const startDate = moment(state.selectedDate).startOf('day');
        const endDate = moment(state.selectedDate).endOf('day');

        try {
            const response = await axios.get('appointments', {
                params: {
                    account_id: rootState.authUser.account.id,
                    startDate: startDate.format(),
                    endDate: endDate.format(),
                },
            });

            commit('setAppointments', response.data.data);
        } finally {
            wait.end('fetching.appointments');
        }
    },

    async createAppointment({ commit, rootState }, appointment) {
        const response = await axios.post('appointments', {
            account_id: rootState.authUser.account.id,
            category: 'appointment_service',

            contact_id: appointment.contact_id,
            datetime: appointment.datetime,
            notes: appointment.notes,
            related_vehicle_make: appointment.related_vehicle_make,
        });

        commit('addAppointment', response.data.data);
    },

    async updateAppointment({ commit }, appointment) {
        const response = await axios.put(`appointments/${appointment.id}`, {
            contact_id: appointment.contact_id,
            datetime: appointment.datetime,
            notes: appointment.notes,
            related_vehicle_make: appointment.related_vehicle_make,
        });

        commit('updateAppointment', response.data.data);
    },

    deleteAppointments({ commit }, appointments) {
        const ids = [];

        appointments.forEach(appointment => {
            ids.push(appointment.id);
            commit('deleteAppointment', appointment);
        });

        axios.delete(`appointments/${ids.join()}`);
    },

    async loadImportHistory({ commit, rootState }) {
        wait.start('fetching.history');

        try {
            const response = await axios.get('imports', {
                params: {
                    account_id: rootState.authUser.account.id,
                },
            });

            commit('setImportHistory', response.data.data);
        } finally {
            wait.end('fetching.history');
        }
    },
};
